// This file is auto-generated by @hey-api/openapi-ts

export const ActionSchema = {
    properties: {
        name: {
            type: 'string',
            title: 'Name'
        },
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        method: {
            type: 'string',
            title: 'Method'
        },
        href: {
            type: 'string',
            title: 'Href'
        },
        operation: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Operation'
        }
    },
    type: 'object',
    required: [
        'name',
        'title',
        'method',
        'href',
        'operation'
    ],
    title: 'Action',
    description: 'Action.'
} as const;

export const ApiKeySchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity',
            description: 'ID of the API key'
        },
        name: {
            type: 'string',
            title: 'Name',
            description: 'Name of the API key'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At',
            description: 'Creation timestamp'
        },
        expires_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expires At',
            description: 'Expiration timestamp'
        },
        last_used_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Used At',
            description: 'Last used timestamp'
        }
    },
    type: 'object',
    required: [
        'identity',
        'name',
        'created_at'
    ],
    title: 'ApiKey',
    description: 'Schema for an API key.'
} as const;

export const ApiKeyCreatedSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity',
            description: 'ID of the API key'
        },
        name: {
            type: 'string',
            title: 'Name',
            description: 'Name of the API key'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At',
            description: 'Creation timestamp'
        },
        expires_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expires At',
            description: 'Expiration timestamp'
        },
        last_used_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Used At',
            description: 'Last used timestamp'
        },
        key: {
            type: 'string',
            title: 'Key',
            description: 'The API key (only shown once)'
        }
    },
    type: 'object',
    required: [
        'identity',
        'name',
        'created_at',
        'key'
    ],
    title: 'ApiKeyCreated',
    description: 'Schema for a newly created API key.'
} as const;

export const ApiKeysListSchema = {
    properties: {
        api_keys: {
            items: {
                $ref: '#/components/schemas/ApiKey'
            },
            type: 'array',
            title: 'Api Keys',
            description: 'List of API keys'
        }
    },
    type: 'object',
    required: [
        'api_keys'
    ],
    title: 'ApiKeysList',
    description: 'Schema for a list of API keys.'
} as const;

export const ArtefactSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        mimetype: {
            type: 'string',
            title: 'Mimetype'
        },
        links: {
            additionalProperties: {
                $ref: '#/components/schemas/Hateoas'
            },
            type: 'object',
            title: 'Links',
            default: {}
        },
        preview: {
            anyOf: [
                {
                    type: 'string',
                    pattern: 'data:(?P<mimetype>[\\w]+\\/[\\w\\-\\+\\.]+)?(?:\\;name\\=(?P<name>[\\w\\.\\-%!*\'~\\(\\)]+))?(?:\\;charset\\=(?P<charset>[\\w\\-\\+\\.]+))?(?P<base64>\\;base64)?,(?P<data>.*)',
                    title: 'DataURI',
                    examples: [
                        'data:text/plain;charset=utf-8;base64,VGhlIHF1aWNrIGJyb3duIGZveCBqdW1wZWQgb3ZlciB0aGUgbGF6eSBkb2cu'
                    ]
                },
                {
                    type: 'null'
                }
            ],
            title: 'Preview'
        }
    },
    type: 'object',
    required: [
        'identity',
        'name',
        'mimetype',
        'preview'
    ],
    title: 'Artefact',
    description: 'Response body for Artefact.'
} as const;

export const ArtefactGroupWithArtefactsSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        artefacts: {
            items: {
                anyOf: [
                    {
                        $ref: '#/components/schemas/Artefact'
                    },
                    {
                        $ref: '#/components/schemas/ArtefactGroupWithArtefacts'
                    }
                ]
            },
            type: 'array',
            title: 'Artefacts'
        }
    },
    type: 'object',
    required: [
        'identity',
        'name',
        'artefacts'
    ],
    title: 'ArtefactGroupWithArtefacts',
    description: 'Response body for Artefact group with artefacts.'
} as const;

export const Body_create_api_integration_stek_integration_mgt_integration_settings__integration_type__postSchema = {
    properties: {
        api_key: {
            type: 'string',
            title: 'Api Key'
        },
        host: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Host'
        }
    },
    type: 'object',
    required: [
        'api_key'
    ],
    title: 'Body_create_api_integration_stek_integration_mgt_integration_settings__integration_type__post'
} as const;

export const Body_create_api_key__user_api_key_postSchema = {
    properties: {
        name: {
            type: 'string',
            title: 'Name'
        },
        expires_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Expires At'
        }
    },
    type: 'object',
    required: [
        'name'
    ],
    title: 'Body_create_api_key__user_api_key_post'
} as const;

export const Body_generate_authorization_code_integrations_oauth2_server_authorize_postSchema = {
    properties: {
        organization_id: {
            type: 'string',
            title: 'Organization Id'
        },
        stek_id: {
            type: 'string',
            title: 'Stek Id'
        },
        client_id: {
            type: 'string',
            title: 'Client Id'
        },
        redirect_uri: {
            type: 'string',
            title: 'Redirect Uri'
        },
        scope: {
            type: 'string',
            title: 'Scope'
        },
        code_challenge: {
            type: 'string',
            title: 'Code Challenge'
        },
        code_challenge_method: {
            type: 'string',
            title: 'Code Challenge Method',
            default: 'S256'
        },
        state: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'State'
        },
        authorization_token: {
            type: 'string',
            title: 'Authorization Token'
        },
        organization_header: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Organization Header'
        },
        stek_header: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Stek Header'
        }
    },
    type: 'object',
    required: [
        'organization_id',
        'stek_id',
        'client_id',
        'redirect_uri',
        'scope',
        'code_challenge',
        'authorization_token'
    ],
    title: 'Body_generate_authorization_code_integrations_oauth2_server_authorize_post'
} as const;

export const Body_start_biz_artefact_management_add_artefact_group_start_postSchema = {
    properties: {
        owner_id: {
            type: 'string',
            title: 'Owner Id'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Name'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            description: 'Added {artefact.name}',
            default: ''
        }
    },
    type: 'object',
    required: [
        'owner_id',
        'name'
    ],
    title: 'Body_start_biz_artefact_management_add_artefact_group_start_post'
} as const;

export const Body_start_biz_artefact_management_add_artefact_start_postSchema = {
    properties: {
        owner_id: {
            type: 'string',
            title: 'Owner Id'
        },
        file_: {
            type: 'string',
            format: 'binary',
            title: 'File'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            description: 'Added {artefact.name}',
            default: ''
        }
    },
    type: 'object',
    required: [
        'owner_id',
        'file_'
    ],
    title: 'Body_start_biz_artefact_management_add_artefact_start_post'
} as const;

export const Body_start_biz_artefact_management_get_artefact_start_postSchema = {
    properties: {
        artefact_id: {
            type: 'string',
            title: 'Artefact Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        }
    },
    type: 'object',
    required: [
        'artefact_id'
    ],
    title: 'Body_start_biz_artefact_management_get_artefact_start_post'
} as const;

export const Body_start_biz_artefact_management_get_artefacts_tree_start_postSchema = {
    properties: {
        artefact_group_id: {
            type: 'string',
            title: 'Artefact Group Id'
        }
    },
    type: 'object',
    required: [
        'artefact_group_id'
    ],
    title: 'Body_start_biz_artefact_management_get_artefacts_tree_start_post'
} as const;

export const Body_start_biz_artefact_management_get_history_start_postSchema = {
    properties: {
        artefact_id: {
            type: 'string',
            title: 'Artefact Id'
        },
        limit: {
            type: 'integer',
            title: 'Limit',
            default: 10
        },
        offset: {
            type: 'integer',
            title: 'Offset',
            default: 0
        }
    },
    type: 'object',
    required: [
        'artefact_id'
    ],
    title: 'Body_start_biz_artefact_management_get_history_start_post'
} as const;

export const Body_start_biz_artefact_management_remove_artefact_group_start_postSchema = {
    properties: {
        artefact_group_id: {
            type: 'string',
            title: 'Artefact Group Id'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            default: ''
        }
    },
    type: 'object',
    required: [
        'artefact_group_id'
    ],
    title: 'Body_start_biz_artefact_management_remove_artefact_group_start_post'
} as const;

export const Body_start_biz_artefact_management_remove_artefact_start_postSchema = {
    properties: {
        artefact_id: {
            type: 'string',
            title: 'Artefact Id'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            default: ''
        }
    },
    type: 'object',
    required: [
        'artefact_id'
    ],
    title: 'Body_start_biz_artefact_management_remove_artefact_start_post'
} as const;

export const Body_start_biz_artefact_management_rename_artefact_group_start_postSchema = {
    properties: {
        artefact_group_id: {
            type: 'string',
            title: 'Artefact Group Id'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Name'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            default: ''
        }
    },
    type: 'object',
    required: [
        'artefact_group_id',
        'name'
    ],
    title: 'Body_start_biz_artefact_management_rename_artefact_group_start_post'
} as const;

export const Body_start_biz_artefact_management_rename_artefact_start_postSchema = {
    properties: {
        artefact_id: {
            type: 'string',
            title: 'Artefact Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            default: ''
        }
    },
    type: 'object',
    required: [
        'artefact_id',
        'name'
    ],
    title: 'Body_start_biz_artefact_management_rename_artefact_start_post'
} as const;

export const Body_start_biz_artefact_management_restore_historical_artefact_start_postSchema = {
    properties: {
        artefact_id: {
            type: 'string',
            title: 'Artefact Id'
        },
        revision: {
            type: 'string',
            title: 'Revision'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            default: ''
        }
    },
    type: 'object',
    required: [
        'artefact_id',
        'revision'
    ],
    title: 'Body_start_biz_artefact_management_restore_historical_artefact_start_post'
} as const;

export const Body_start_biz_artefact_management_update_artefact_content_start_postSchema = {
    properties: {
        artefact_id: {
            type: 'string',
            title: 'Artefact Id'
        },
        file_: {
            type: 'string',
            format: 'binary',
            title: 'File'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            description: 'Added {artefact.name}',
            default: ''
        }
    },
    type: 'object',
    required: [
        'artefact_id',
        'file_'
    ],
    title: 'Body_start_biz_artefact_management_update_artefact_content_start_post'
} as const;

export const Body_start_biz_artefact_management_update_artefact_start_postSchema = {
    properties: {
        artefact_id: {
            type: 'string',
            title: 'Artefact Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string',
                    minLength: 1
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        content: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Content'
        },
        commit_message: {
            type: 'string',
            title: 'Commit Message',
            description: 'Added {artefact.name}',
            default: ''
        }
    },
    type: 'object',
    required: [
        'artefact_id'
    ],
    title: 'Body_start_biz_artefact_management_update_artefact_start_post'
} as const;

export const Body_start_biz_entities__entity_type___entity_id___attribute__restore_postSchema = {
    properties: {
        revision: {
            type: 'string',
            title: 'Revision'
        }
    },
    type: 'object',
    required: [
        'revision'
    ],
    title: 'Body_start_biz_entities__entity_type___entity_id___attribute__restore_post'
} as const;

export const Body_start_dashboard_dashboard_mgt_update_dashboard_start_postSchema = {
    properties: {
        dashboard_id: {
            type: 'string',
            title: 'Dashboard Id'
        },
        widgets: {
            items: {
                $ref: '#/components/schemas/Widget'
            },
            type: 'array',
            title: 'Widgets'
        }
    },
    type: 'object',
    required: [
        'dashboard_id',
        'widgets'
    ],
    title: 'Body_start_dashboard_dashboard_mgt_update_dashboard_start_post'
} as const;

export const Body_start_domain_business_entity_mgt_create_business_entity_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        definition: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Definition'
        },
        relationships: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Relationships',
            description: 'JSON string containing an array of relationship objects. Each relationship should have \'type\', \'other_id\', and \'direction\' fields. Example: \'[{"type": "depends on", "other_id": "entity2", "direction": "outgoing"}]\''
        }
    },
    type: 'object',
    required: [
        'domain_id',
        'name'
    ],
    title: 'Body_start_domain_business_entity_mgt_create_business_entity_start_post'
} as const;

export const Body_start_domain_business_entity_mgt_delete_business_entity_start_postSchema = {
    properties: {
        business_entity_id: {
            type: 'string',
            title: 'Business Entity Id'
        }
    },
    type: 'object',
    required: [
        'business_entity_id'
    ],
    title: 'Body_start_domain_business_entity_mgt_delete_business_entity_start_post'
} as const;

export const Body_start_domain_business_entity_mgt_get_business_entities_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: [
        'domain_id'
    ],
    title: 'Body_start_domain_business_entity_mgt_get_business_entities_start_post'
} as const;

export const Body_start_domain_business_entity_mgt_get_business_entity_start_postSchema = {
    properties: {
        business_entity_id: {
            type: 'string',
            title: 'Business Entity Id'
        }
    },
    type: 'object',
    required: [
        'business_entity_id'
    ],
    title: 'Body_start_domain_business_entity_mgt_get_business_entity_start_post'
} as const;

export const Body_start_domain_business_entity_mgt_update_business_entity_start_postSchema = {
    properties: {
        business_entity_id: {
            type: 'string',
            title: 'Business Entity Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string',
                    minLength: 1
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        definition: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Definition'
        },
        relationships: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Relationships',
            description: 'JSON string containing an array of relationship objects. Each relationship should have \'type\', \'other_id\', and \'direction\' fields. Example: \'[{"type": "depends on", "other_id": "entity2", "direction": "outgoing"}]\''
        }
    },
    type: 'object',
    required: [
        'business_entity_id'
    ],
    title: 'Body_start_domain_business_entity_mgt_update_business_entity_start_post'
} as const;

export const Body_start_domain_domain_mgt_create_domain_start_postSchema = {
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: [
        'name'
    ],
    title: 'Body_start_domain_domain_mgt_create_domain_start_post'
} as const;

export const Body_start_domain_domain_mgt_delete_domain_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: [
        'domain_id'
    ],
    title: 'Body_start_domain_domain_mgt_delete_domain_start_post'
} as const;

export const Body_start_domain_domain_mgt_get_domain_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        }
    },
    type: 'object',
    required: [
        'domain_id'
    ],
    title: 'Body_start_domain_domain_mgt_get_domain_start_post'
} as const;

export const Body_start_domain_domain_mgt_update_domain_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string',
                    minLength: 1
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: [
        'domain_id'
    ],
    title: 'Body_start_domain_domain_mgt_update_domain_start_post'
} as const;

export const Body_start_domain_role_mgt_create_role_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: [
        'domain_id',
        'name'
    ],
    title: 'Body_start_domain_role_mgt_create_role_start_post'
} as const;

export const Body_start_domain_role_mgt_delete_role_start_postSchema = {
    properties: {
        role_id: {
            type: 'string',
            title: 'Role Id'
        }
    },
    type: 'object',
    required: [
        'role_id'
    ],
    title: 'Body_start_domain_role_mgt_delete_role_start_post'
} as const;

export const Body_start_domain_role_mgt_get_role_start_postSchema = {
    properties: {
        role_id: {
            type: 'string',
            title: 'Role Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        }
    },
    type: 'object',
    required: [
        'role_id'
    ],
    title: 'Body_start_domain_role_mgt_get_role_start_post'
} as const;

export const Body_start_domain_role_mgt_get_roles_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: [
        'domain_id'
    ],
    title: 'Body_start_domain_role_mgt_get_roles_start_post'
} as const;

export const Body_start_domain_role_mgt_update_role_start_postSchema = {
    properties: {
        role_id: {
            type: 'string',
            title: 'Role Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string',
                    minLength: 1
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: [
        'role_id'
    ],
    title: 'Body_start_domain_role_mgt_update_role_start_post'
} as const;

export const Body_start_process_lane_mgt_get_lane_by_bpmn_id_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        lane_id: {
            type: 'string',
            title: 'Lane Id'
        }
    },
    type: 'object',
    required: [
        'process_id',
        'bpmn_id',
        'lane_id'
    ],
    title: 'Body_start_process_lane_mgt_get_lane_by_bpmn_id_start_post'
} as const;

export const Body_start_process_lane_mgt_get_lane_by_role_id_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        role_id: {
            type: 'string',
            title: 'Role Id'
        },
        lane_id: {
            type: 'string',
            title: 'Lane Id'
        }
    },
    type: 'object',
    required: [
        'process_id',
        'role_id',
        'lane_id'
    ],
    title: 'Body_start_process_lane_mgt_get_lane_by_role_id_start_post'
} as const;

export const Body_start_process_lane_mgt_get_lane_start_postSchema = {
    properties: {
        lane_id: {
            type: 'string',
            title: 'Lane Id'
        }
    },
    type: 'object',
    required: [
        'lane_id'
    ],
    title: 'Body_start_process_lane_mgt_get_lane_start_post'
} as const;

export const Body_start_process_lane_mgt_get_lanes_by_process_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        }
    },
    type: 'object',
    required: [
        'process_id'
    ],
    title: 'Body_start_process_lane_mgt_get_lanes_by_process_start_post'
} as const;

export const Body_start_process_process_element_mgt_archive_process_element_start_postSchema = {
    properties: {
        task_id: {
            type: 'string',
            title: 'Task Id'
        }
    },
    type: 'object',
    required: [
        'task_id'
    ],
    title: 'Body_start_process_process_element_mgt_archive_process_element_start_post'
} as const;

export const Body_start_process_process_element_mgt_delete_event_start_postSchema = {
    properties: {
        event_id: {
            type: 'string',
            title: 'Event Id'
        }
    },
    type: 'object',
    required: [
        'event_id'
    ],
    title: 'Body_start_process_process_element_mgt_delete_event_start_post'
} as const;

export const Body_start_process_process_element_mgt_delete_flow_start_postSchema = {
    properties: {
        flow_id: {
            type: 'string',
            title: 'Flow Id'
        }
    },
    type: 'object',
    required: [
        'flow_id'
    ],
    title: 'Body_start_process_process_element_mgt_delete_flow_start_post'
} as const;

export const Body_start_process_process_element_mgt_delete_gateway_start_postSchema = {
    properties: {
        gateway_id: {
            type: 'string',
            title: 'Gateway Id'
        }
    },
    type: 'object',
    required: [
        'gateway_id'
    ],
    title: 'Body_start_process_process_element_mgt_delete_gateway_start_post'
} as const;

export const Body_start_process_process_element_mgt_delete_task_start_postSchema = {
    properties: {
        task_id: {
            type: 'string',
            title: 'Task Id'
        }
    },
    type: 'object',
    required: [
        'task_id'
    ],
    title: 'Body_start_process_process_element_mgt_delete_task_start_post'
} as const;

export const Body_start_process_process_element_mgt_generate_user_interface_start_postSchema = {
    properties: {
        task_id: {
            type: 'string',
            title: 'Task Id'
        }
    },
    type: 'object',
    required: [
        'task_id'
    ],
    title: 'Body_start_process_process_element_mgt_generate_user_interface_start_post'
} as const;

export const Body_start_process_process_element_mgt_get_event_start_postSchema = {
    properties: {
        event_id: {
            type: 'string',
            title: 'Event Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        },
        include_archived: {
            type: 'boolean',
            title: 'Include Archived',
            default: false
        }
    },
    type: 'object',
    required: [
        'event_id'
    ],
    title: 'Body_start_process_process_element_mgt_get_event_start_post'
} as const;

export const Body_start_process_process_element_mgt_get_flow_start_postSchema = {
    properties: {
        flow_id: {
            type: 'string',
            title: 'Flow Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        },
        include_archived: {
            type: 'boolean',
            title: 'Include Archived',
            default: false
        }
    },
    type: 'object',
    required: [
        'flow_id'
    ],
    title: 'Body_start_process_process_element_mgt_get_flow_start_post'
} as const;

export const Body_start_process_process_element_mgt_get_gateway_start_postSchema = {
    properties: {
        gateway_id: {
            type: 'string',
            title: 'Gateway Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        },
        include_archived: {
            type: 'boolean',
            title: 'Include Archived',
            default: false
        }
    },
    type: 'object',
    required: [
        'gateway_id'
    ],
    title: 'Body_start_process_process_element_mgt_get_gateway_start_post'
} as const;

export const Body_start_process_process_element_mgt_get_process_element_by_bpmn_id_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        include_archived: {
            type: 'boolean',
            title: 'Include Archived',
            default: false
        },
        task_id: {
            type: 'string',
            title: 'Task Id'
        }
    },
    type: 'object',
    required: [
        'process_id',
        'bpmn_id',
        'task_id'
    ],
    title: 'Body_start_process_process_element_mgt_get_process_element_by_bpmn_id_start_post'
} as const;

export const Body_start_process_process_element_mgt_get_process_elements_by_process_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        include_archived: {
            type: 'boolean',
            title: 'Include Archived',
            default: false
        }
    },
    type: 'object',
    required: [
        'process_id'
    ],
    title: 'Body_start_process_process_element_mgt_get_process_elements_by_process_start_post'
} as const;

export const Body_start_process_process_element_mgt_get_task_start_postSchema = {
    properties: {
        task_id: {
            type: 'string',
            title: 'Task Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        },
        include_archived: {
            type: 'boolean',
            title: 'Include Archived',
            default: false
        }
    },
    type: 'object',
    required: [
        'task_id'
    ],
    title: 'Body_start_process_process_element_mgt_get_task_start_post'
} as const;

export const Body_start_process_process_element_mgt_unarchive_process_element_start_postSchema = {
    properties: {
        process_element_id: {
            type: 'string',
            title: 'Process Element Id'
        },
        task_id: {
            type: 'string',
            title: 'Task Id'
        }
    },
    type: 'object',
    required: [
        'process_element_id',
        'task_id'
    ],
    title: 'Body_start_process_process_element_mgt_unarchive_process_element_start_post'
} as const;

export const Body_start_process_process_element_mgt_update_event_start_postSchema = {
    properties: {
        event_id: {
            type: 'string',
            title: 'Event Id'
        },
        bpmn_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bpmn Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: [
        'event_id'
    ],
    title: 'Body_start_process_process_element_mgt_update_event_start_post'
} as const;

export const Body_start_process_process_element_mgt_update_flow_start_postSchema = {
    properties: {
        flow_id: {
            type: 'string',
            title: 'Flow Id'
        },
        bpmn_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bpmn Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: [
        'flow_id'
    ],
    title: 'Body_start_process_process_element_mgt_update_flow_start_post'
} as const;

export const Body_start_process_process_element_mgt_update_gateway_start_postSchema = {
    properties: {
        gateway_id: {
            type: 'string',
            title: 'Gateway Id'
        },
        bpmn_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bpmn Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: [
        'gateway_id'
    ],
    title: 'Body_start_process_process_element_mgt_update_gateway_start_post'
} as const;

export const Body_start_process_process_element_mgt_update_task_start_postSchema = {
    properties: {
        task_id: {
            type: 'string',
            title: 'Task Id'
        },
        bpmn_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Bpmn Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        ui_code: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Ui Code'
        }
    },
    type: 'object',
    required: [
        'task_id'
    ],
    title: 'Body_start_process_process_element_mgt_update_task_start_post'
} as const;

export const Body_start_process_process_mgt_create_process_start_postSchema = {
    properties: {
        product_id: {
            type: 'string',
            title: 'Product Id'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        process_definition: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Process Definition'
        },
        process_definition_preview: {
            anyOf: [
                {
                    type: 'string',
                    pattern: 'data:(?P<mimetype>[\\w]+\\/[\\w\\-\\+\\.]+)?(?:\\;name\\=(?P<name>[\\w\\.\\-%!*\'~\\(\\)]+))?(?:\\;charset\\=(?P<charset>[\\w\\-\\+\\.]+))?(?P<base64>\\;base64)?,(?P<data>.*)',
                    title: 'DataURI',
                    examples: [
                        'data:text/plain;charset=utf-8;base64,VGhlIHF1aWNrIGJyb3duIGZveCBqdW1wZWQgb3ZlciB0aGUgbGF6eSBkb2cu'
                    ]
                },
                {
                    type: 'null'
                }
            ],
            title: 'Process Definition Preview'
        }
    },
    type: 'object',
    required: [
        'product_id',
        'name'
    ],
    title: 'Body_start_process_process_mgt_create_process_start_post'
} as const;

export const Body_start_process_process_mgt_delete_process_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        }
    },
    type: 'object',
    required: [
        'process_id'
    ],
    title: 'Body_start_process_process_mgt_delete_process_start_post'
} as const;

export const Body_start_process_process_mgt_deploy_process_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        definition_path: {
            type: 'string',
            title: 'Definition Path'
        }
    },
    type: 'object',
    required: [
        'process_id',
        'definition_path'
    ],
    title: 'Body_start_process_process_mgt_deploy_process_start_post'
} as const;

export const Body_start_process_process_mgt_generate_definition_xml_start_postSchema = {
    properties: {
        prompt: {
            type: 'string',
            maxLength: 50000,
            title: 'Prompt'
        },
        process_id: {
            type: 'string',
            title: 'Process Id'
        }
    },
    type: 'object',
    required: [
        'prompt',
        'process_id'
    ],
    title: 'Body_start_process_process_mgt_generate_definition_xml_start_post'
} as const;

export const Body_start_process_process_mgt_get_process_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        }
    },
    type: 'object',
    required: [
        'process_id'
    ],
    title: 'Body_start_process_process_mgt_get_process_start_post'
} as const;

export const Body_start_process_process_mgt_get_processes_by_product_start_postSchema = {
    properties: {
        product_id: {
            type: 'string',
            title: 'Product Id'
        }
    },
    type: 'object',
    required: [
        'product_id'
    ],
    title: 'Body_start_process_process_mgt_get_processes_by_product_start_post'
} as const;

export const Body_start_process_process_mgt_move_process_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        target_product_id: {
            type: 'string',
            title: 'Target Product Id'
        }
    },
    type: 'object',
    required: [
        'process_id',
        'target_product_id'
    ],
    title: 'Body_start_process_process_mgt_move_process_start_post'
} as const;

export const Body_start_process_process_mgt_update_process_start_postSchema = {
    properties: {
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string',
                    minLength: 1
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        process_definition: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Process Definition'
        },
        process_definition_preview: {
            anyOf: [
                {
                    type: 'string',
                    pattern: 'data:(?P<mimetype>[\\w]+\\/[\\w\\-\\+\\.]+)?(?:\\;name\\=(?P<name>[\\w\\.\\-%!*\'~\\(\\)]+))?(?:\\;charset\\=(?P<charset>[\\w\\-\\+\\.]+))?(?P<base64>\\;base64)?,(?P<data>.*)',
                    title: 'DataURI',
                    examples: [
                        'data:text/plain;charset=utf-8;base64,VGhlIHF1aWNrIGJyb3duIGZveCBqdW1wZWQgb3ZlciB0aGUgbGF6eSBkb2cu'
                    ]
                },
                {
                    type: 'null'
                }
            ],
            title: 'Process Definition Preview'
        }
    },
    type: 'object',
    required: [
        'process_id'
    ],
    title: 'Body_start_process_process_mgt_update_process_start_post'
} as const;

export const Body_start_product_product_mgt_create_product_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        },
        name: {
            type: 'string',
            minLength: 1,
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: [
        'domain_id',
        'name'
    ],
    title: 'Body_start_product_product_mgt_create_product_start_post'
} as const;

export const Body_start_product_product_mgt_delete_product_start_postSchema = {
    properties: {
        product_id: {
            type: 'string',
            title: 'Product Id'
        }
    },
    type: 'object',
    required: [
        'product_id'
    ],
    title: 'Body_start_product_product_mgt_delete_product_start_post'
} as const;

export const Body_start_product_product_mgt_get_product_start_postSchema = {
    properties: {
        product_id: {
            type: 'string',
            title: 'Product Id'
        },
        revision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revision'
        }
    },
    type: 'object',
    required: [
        'product_id'
    ],
    title: 'Body_start_product_product_mgt_get_product_start_post'
} as const;

export const Body_start_product_product_mgt_get_products_by_domain_start_postSchema = {
    properties: {
        domain_id: {
            type: 'string',
            title: 'Domain Id'
        }
    },
    type: 'object',
    required: [
        'domain_id'
    ],
    title: 'Body_start_product_product_mgt_get_products_by_domain_start_post'
} as const;

export const Body_start_product_product_mgt_move_product_start_postSchema = {
    properties: {
        product_id: {
            type: 'string',
            title: 'Product Id'
        },
        target_domain_id: {
            type: 'string',
            title: 'Target Domain Id'
        }
    },
    type: 'object',
    required: [
        'product_id',
        'target_domain_id'
    ],
    title: 'Body_start_product_product_mgt_move_product_start_post'
} as const;

export const Body_start_product_product_mgt_update_product_start_postSchema = {
    properties: {
        product_id: {
            type: 'string',
            title: 'Product Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string',
                    minLength: 1
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: [
        'product_id'
    ],
    title: 'Body_start_product_product_mgt_update_product_start_post'
} as const;

export const Body_start_stek_stek_mgt_create_stek_start_postSchema = {
    properties: {
        name: {
            type: 'string',
            minLength: 1,
            title: 'Name'
        },
        fqdn: {
            type: 'string',
            title: 'Fqdn',
            default: ''
        },
        logo: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Logo'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        }
    },
    type: 'object',
    required: [
        'name'
    ],
    title: 'Body_start_stek_stek_mgt_create_stek_start_post'
} as const;

export const Body_start_stek_stek_mgt_generate_stek_details_start_postSchema = {
    properties: {
        sources: {
            items: {
                type: 'string'
            },
            type: 'array',
            maxItems: 2500,
            title: 'Sources'
        },
        stek_id: {
            type: 'string',
            title: 'Stek Id'
        }
    },
    type: 'object',
    required: [
        'sources',
        'stek_id'
    ],
    title: 'Body_start_stek_stek_mgt_generate_stek_details_start_post'
} as const;

export const Body_start_stek_stek_mgt_update_stek_start_postSchema = {
    properties: {
        stek_id: {
            type: 'string',
            title: 'Stek Id'
        },
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        fqdn: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Fqdn'
        },
        logo: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Logo'
        },
        description: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        mission: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mission'
        },
        vision: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Vision'
        },
        core_values: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Core Values'
        },
        specializations: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Specializations'
        },
        target_markets: {
            anyOf: [
                {
                    type: 'string',
                    format: 'binary'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Target Markets'
        }
    },
    type: 'object',
    required: [
        'stek_id'
    ],
    title: 'Body_start_stek_stek_mgt_update_stek_start_post'
} as const;

export const Body_start_workspace_worktree_mgt_get_worktree_start_postSchema = {
    properties: {
        workspace_id: {
            type: 'string',
            title: 'Workspace Id'
        }
    },
    type: 'object',
    required: [
        'workspace_id'
    ],
    title: 'Body_start_workspace_worktree_mgt_get_worktree_start_post'
} as const;

export const Body_test_integration_connection_stek_integration_mgt_integration_test__integration_type__postSchema = {
    properties: {
        api_key: {
            type: 'string',
            title: 'Api Key'
        },
        host: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Host'
        }
    },
    type: 'object',
    required: [
        'api_key'
    ],
    title: 'Body_test_integration_connection_stek_integration_mgt_integration_test__integration_type__post'
} as const;

export const Body_token_endpoint_integrations_oauth2_server_token_postSchema = {
    properties: {
        grant_type: {
            type: 'string',
            title: 'Grant Type'
        },
        code: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Code'
        },
        redirect_uri: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Redirect Uri'
        },
        code_verifier: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Code Verifier'
        },
        client_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Client Id'
        },
        refresh_token: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Refresh Token'
        }
    },
    type: 'object',
    required: [
        'grant_type'
    ],
    title: 'Body_token_endpoint_integrations_oauth2_server_token_post'
} as const;

export const BusinessEntitySchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        definition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        relationships: {
            items: {
                $ref: '#/components/schemas/BusinessEntityRelationship'
            },
            type: 'array',
            title: 'Relationships'
        }
    },
    type: 'object',
    required: [
        'identity',
        'name',
        'relationships'
    ],
    title: 'BusinessEntity',
    description: 'Business entity response.'
} as const;

export const BusinessEntityRelationshipSchema = {
    properties: {
        type: {
            type: 'string',
            title: 'Type'
        },
        other_id: {
            type: 'string',
            title: 'Other Id'
        },
        direction: {
            $ref: '#/components/schemas/RelationshipDirection'
        }
    },
    type: 'object',
    required: [
        'type',
        'other_id',
        'direction'
    ],
    title: 'BusinessEntityRelationship',
    description: 'Business entity relationship for API requests/responses.'
} as const;

export const ClientRegistrationRequestSchema = {
    properties: {
        redirect_uris: {
            items: {
                type: 'string',
                minLength: 1,
                format: 'uri'
            },
            type: 'array',
            title: 'Redirect Uris'
        },
        client_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Client Name'
        },
        scope: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Scope'
        },
        token_endpoint_auth_method: {
            type: 'string',
            title: 'Token Endpoint Auth Method',
            default: 'none'
        },
        grant_types: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Grant Types',
            default: [
                'authorization_code',
                'refresh_token'
            ]
        },
        response_types: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Response Types',
            default: [
                'code'
            ]
        }
    },
    type: 'object',
    required: [
        'redirect_uris'
    ],
    title: 'ClientRegistrationRequest',
    description: 'Client registration request.'
} as const;

export const ClientRegistrationResponseSchema = {
    properties: {
        client_id: {
            type: 'string',
            title: 'Client Id'
        },
        redirect_uris: {
            items: {
                type: 'string',
                minLength: 1,
                format: 'uri'
            },
            type: 'array',
            title: 'Redirect Uris'
        },
        client_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Client Name'
        },
        scope: {
            type: 'string',
            title: 'Scope'
        },
        token_endpoint_auth_method: {
            type: 'string',
            title: 'Token Endpoint Auth Method',
            default: 'none'
        },
        grant_types: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Grant Types',
            default: [
                'authorization_code',
                'refresh_token'
            ]
        },
        response_types: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Response Types',
            default: [
                'code'
            ]
        }
    },
    type: 'object',
    required: [
        'client_id',
        'redirect_uris',
        'scope'
    ],
    title: 'ClientRegistrationResponse',
    description: 'Client registration response.'
} as const;

export const ClusterRoleSchema = {
    type: 'string',
    enum: [
        'user',
        'user-manager'
    ],
    title: 'ClusterRole',
    description: 'The role of the user across the organization.'
} as const;

export const ContributorSchema = {
    properties: {
        name: {
            type: 'string',
            title: 'Name'
        },
        email: {
            type: 'string',
            title: 'Email'
        },
        date: {
            type: 'string',
            title: 'Date'
        }
    },
    type: 'object',
    required: [
        'name',
        'email',
        'date'
    ],
    title: 'Contributor',
    description: 'An author or committer of a HistoryEntry.'
} as const;

export const CreateEntitySchema = {
    properties: {
        name: {
            type: 'string',
            title: 'Name'
        },
        type: {
            type: 'string',
            title: 'Type'
        },
        description: {
            type: 'string',
            title: 'Description'
        }
    },
    type: 'object',
    required: [
        'name',
        'type',
        'description'
    ],
    title: 'CreateEntity',
    description: 'Function to create a connection between two elements.'
} as const;

export const CreateUserSchema = {
    properties: {
        email: {
            type: 'string',
            title: 'Email'
        },
        name: {
            type: 'string',
            title: 'Name'
        }
    },
    type: 'object',
    required: [
        'email',
        'name'
    ],
    title: 'CreateUser',
    description: 'Create a new user.'
} as const;

export const DashboardSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        widgets: {
            items: {
                $ref: '#/components/schemas/Widget'
            },
            type: 'array',
            title: 'Widgets',
            default: []
        }
    },
    type: 'object',
    required: [
        'identity',
        'name'
    ],
    title: 'Dashboard',
    description: 'Dashboard within MyStekz.'
} as const;

export const DomainSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: [
        'identity',
        'name'
    ],
    title: 'Domain',
    description: 'Request body for Domain.'
} as const;

export const DomainInTreeSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        products: {
            items: {
                $ref: '#/components/schemas/ProductInTree'
            },
            type: 'array',
            title: 'Products'
        }
    },
    type: 'object',
    required: [
        'identity',
        'name',
        'products'
    ],
    title: 'DomainInTree',
    description: 'Domain representation inside worktree, does not describe Domain.'
} as const;

export const DomainRoleSchema = {
    properties: {
        role_name: {
            type: 'string',
            title: 'Role Name'
        },
        domain_name: {
            type: 'string',
            title: 'Domain Name'
        },
        authorized: {
            type: 'boolean',
            title: 'Authorized'
        }
    },
    type: 'object',
    required: [
        'role_name',
        'domain_name',
        'authorized'
    ],
    title: 'DomainRole',
    description: 'The domain roles in relation to the user.'
} as const;

export const EntityInfoSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        entity_type: {
            $ref: '#/components/schemas/EntityType'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        thumbnail: {
            anyOf: [
                {
                    type: 'string',
                    pattern: 'data:(?P<mimetype>[\\w]+\\/[\\w\\-\\+\\.]+)?(?:\\;name\\=(?P<name>[\\w\\.\\-%!*\'~\\(\\)]+))?(?:\\;charset\\=(?P<charset>[\\w\\-\\+\\.]+))?(?P<base64>\\;base64)?,(?P<data>.*)',
                    title: 'DataURI',
                    examples: [
                        'data:text/plain;charset=utf-8;base64,VGhlIHF1aWNrIGJyb3duIGZveCBqdW1wZWQgb3ZlciB0aGUgbGF6eSBkb2cu'
                    ]
                },
                {
                    type: 'null'
                }
            ],
            title: 'Thumbnail'
        },
        parent: {
            anyOf: [
                {
                    $ref: '#/components/schemas/EntityInfo'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: [
        'identity',
        'entity_type',
        'name'
    ],
    title: 'EntityInfo',
    description: 'Entity information.'
} as const;

export const EntityTypeSchema = {
    type: 'string',
    enum: [
        'organization',
        'stek',
        'domain',
        'product',
        'role',
        'process',
        'task',
        'gateway',
        'event',
        'flow',
        'artefact',
        'artefact_group',
        'business_entity',
        'document'
    ],
    title: 'EntityType'
} as const;

export const GetTaskEvaluationsRequestSchema = {
    properties: {
        task_name: {
            type: 'string',
            title: 'Task Name',
            description: 'Name of the task to get evaluations for'
        }
    },
    type: 'object',
    required: [
        'task_name'
    ],
    title: 'GetTaskEvaluationsRequest',
    description: 'Request to get task evaluations for a specific task name.'
} as const;

export const GetTaskProvidersRequestSchema = {
    properties: {
        task_type: {
            $ref: '#/components/schemas/TaskType',
            description: 'Type of task to get providers for'
        }
    },
    type: 'object',
    required: [
        'task_type'
    ],
    title: 'GetTaskProvidersRequest',
    description: 'Request to get task providers for a specific task type.'
} as const;

export const HTTPValidationErrorSchema = {
    properties: {
        detail: {
            items: {
                $ref: '#/components/schemas/ValidationError'
            },
            type: 'array',
            title: 'Detail'
        }
    },
    type: 'object',
    title: 'HTTPValidationError'
} as const;

export const HateoasSchema = {
    properties: {
        href: {
            type: 'string',
            title: 'Href'
        },
        type: {
            type: 'string',
            title: 'Type'
        }
    },
    type: 'object',
    required: [
        'href',
        'type'
    ],
    title: 'Hateoas',
    description: 'Response body for Hoteos.'
} as const;

export const HistoryEntrySchema = {
    properties: {
        id: {
            type: 'string',
            title: 'Id'
        },
        subject: {
            type: 'string',
            title: 'Subject'
        },
        body: {
            type: 'string',
            title: 'Body'
        },
        author: {
            $ref: '#/components/schemas/Contributor'
        },
        committer: {
            $ref: '#/components/schemas/Contributor'
        }
    },
    type: 'object',
    required: [
        'id',
        'subject',
        'body',
        'author',
        'committer'
    ],
    title: 'HistoryEntry',
    description: 'A value object which represents a point in time of the artefact.'
} as const;

export const HttpDetailSchema = {
    properties: {
        message: {
            type: 'string',
            title: 'Message'
        },
        type: {
            title: 'Type'
        }
    },
    type: 'object',
    required: [
        'message',
        'type'
    ],
    title: 'HttpDetail'
} as const;

export const HttpExceptionModelSchema = {
    properties: {
        detail: {
            items: {
                $ref: '#/components/schemas/HttpDetail'
            },
            type: 'array',
            title: 'Detail'
        }
    },
    type: 'object',
    required: [
        'detail'
    ],
    title: 'HttpExceptionModel'
} as const;

export const IntegrationSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        stek_id: {
            type: 'string',
            title: 'Stek Id'
        },
        user_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Id'
        },
        integration_type: {
            $ref: '#/components/schemas/IntegrationType'
        },
        integration_method: {
            anyOf: [
                {
                    type: 'string',
                    enum: [
                        'oauth2',
                        'api_key'
                    ]
                },
                {
                    type: 'null'
                }
            ],
            title: 'Integration Method'
        },
        created_at: {
            type: 'string',
            format: 'date-time',
            title: 'Created At'
        },
        updated_at: {
            type: 'string',
            format: 'date-time',
            title: 'Updated At'
        },
        last_sync_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Last Sync At'
        },
        is_active: {
            type: 'boolean',
            title: 'Is Active'
        },
        settings: {
            anyOf: [
                {
                    $ref: '#/components/schemas/IntegrationSettings'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: [
        'identity',
        'stek_id',
        'integration_type',
        'integration_method',
        'created_at',
        'updated_at',
        'is_active'
    ],
    title: 'Integration',
    description: 'Integration on a Stek level.'
} as const;

export const IntegrationSettingsSchema = {
    properties: {
        api_key: {
            type: 'string',
            title: 'Api Key',
            default: ''
        },
        host: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Host'
        }
    },
    type: 'object',
    title: 'IntegrationSettings',
    description: 'Base model for integration settings.'
} as const;

export const IntegrationStatusSchema = {
    type: 'string',
    enum: [
        'connected',
        'missing_integration',
        'missing_credentials',
        'error'
    ],
    title: 'IntegrationStatus'
} as const;

export const IntegrationTypeSchema = {
    type: 'string',
    enum: [
        'clickup',
        'gitlab',
        'mcp_oauth2'
    ],
    title: 'IntegrationType',
    description: 'Types of integrations that can be configured for an stek.'
} as const;

export const LaneSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        role_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Role Id'
        }
    },
    type: 'object',
    required: [
        'identity',
        'bpmn_id',
        'name'
    ],
    title: 'Lane',
    description: 'Request body for Lane.'
} as const;

export const LinkPreviewSchema = {
    properties: {
        title: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Title'
        },
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        image: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Image'
        },
        domain: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Domain'
        },
        integration_status: {
            anyOf: [
                {
                    $ref: '#/components/schemas/IntegrationStatus'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    title: 'LinkPreview',
    description: 'Link preview data model for API responses.'
} as const;

export const MeUserSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        email: {
            type: 'string',
            title: 'Email'
        },
        roles: {
            additionalProperties: {
                $ref: '#/components/schemas/ClusterRole'
            },
            type: 'object',
            title: 'Roles'
        },
        profile_picture: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Profile Picture'
        }
    },
    type: 'object',
    required: [
        'identity',
        'name',
        'email',
        'roles'
    ],
    title: 'MeUser',
    description: 'User object which exposes all authorizations roles in all organizatios for the user.'
} as const;

export const ModelConfigSchema = {
    properties: {
        provider: {
            $ref: '#/components/schemas/ModelProvider',
            description: 'Model provider (OpenAI or Anthropic)',
            default: 'openai'
        },
        model: {
            type: 'string',
            title: 'Model',
            description: 'Model name (e.g., gpt-4o, claude-3-sonnet)',
            default: 'gpt-4o'
        },
        temperature: {
            type: 'number',
            title: 'Temperature',
            description: 'Model temperature (0.0 to 1.0)',
            default: 0.2
        },
        max_tokens: {
            type: 'integer',
            title: 'Max Tokens',
            description: 'Maximum tokens to generate',
            default: 1000
        }
    },
    type: 'object',
    title: 'ModelConfig',
    description: 'Model configuration for task evaluation.'
} as const;

export const ModelProviderSchema = {
    type: 'string',
    enum: [
        'openai',
        'anthropic'
    ],
    title: 'ModelProvider',
    description: 'Available model providers.'
} as const;

export const OAuthMetadataSchema = {
    properties: {
        issuer: {
            type: 'string',
            minLength: 1,
            format: 'uri',
            title: 'Issuer'
        },
        authorization_endpoint: {
            type: 'string',
            minLength: 1,
            format: 'uri',
            title: 'Authorization Endpoint'
        },
        token_endpoint: {
            type: 'string',
            minLength: 1,
            format: 'uri',
            title: 'Token Endpoint'
        },
        registration_endpoint: {
            anyOf: [
                {
                    type: 'string',
                    minLength: 1,
                    format: 'uri'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Registration Endpoint'
        },
        revocation_endpoint: {
            anyOf: [
                {
                    type: 'string',
                    minLength: 1,
                    format: 'uri'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Revocation Endpoint'
        },
        scopes_supported: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Scopes Supported',
            default: [
                'mcp'
            ]
        },
        response_types_supported: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Response Types Supported',
            default: [
                'code'
            ]
        },
        grant_types_supported: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Grant Types Supported',
            default: [
                'authorization_code',
                'refresh_token'
            ]
        },
        code_challenge_methods_supported: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Code Challenge Methods Supported',
            default: [
                'S256'
            ]
        },
        token_endpoint_auth_methods_supported: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Token Endpoint Auth Methods Supported',
            default: [
                'none'
            ]
        }
    },
    type: 'object',
    required: [
        'issuer',
        'authorization_endpoint',
        'token_endpoint'
    ],
    title: 'OAuthMetadata',
    description: 'OAuth2 server metadata for discovery.'
} as const;

export const OAuthProtectedResourceMetadataSchema = {
    properties: {
        resource: {
            type: 'string',
            minLength: 1,
            format: 'uri',
            title: 'Resource'
        },
        authorization_servers: {
            items: {
                type: 'string',
                minLength: 1,
                format: 'uri'
            },
            type: 'array',
            title: 'Authorization Servers'
        },
        scopes_supported: {
            items: {
                type: 'string'
            },
            type: 'array',
            title: 'Scopes Supported',
            default: [
                'mcp'
            ]
        },
        resource_name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resource Name'
        },
        resource_documentation: {
            anyOf: [
                {
                    type: 'string',
                    minLength: 1,
                    format: 'uri'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Resource Documentation'
        }
    },
    type: 'object',
    required: [
        'resource',
        'authorization_servers'
    ],
    title: 'OAuthProtectedResourceMetadata',
    description: 'OAuth2 protected resource metadata for discovery (RFC 9728).'
} as const;

export const OrganizationSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        parent_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Parent Id'
        }
    },
    type: 'object',
    required: [
        'identity',
        'name'
    ],
    title: 'Organization',
    description: 'Organization within MyStekz.'
} as const;

export const OrganizationUserSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        email: {
            type: 'string',
            title: 'Email'
        },
        role: {
            $ref: '#/components/schemas/ClusterRole'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        profile_picture: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Profile Picture'
        },
        _actions: {
            items: {
                $ref: '#/components/schemas/Action'
            },
            type: 'array',
            title: 'Actions'
        }
    },
    type: 'object',
    required: [
        'identity',
        'email',
        'role',
        'name'
    ],
    title: 'OrganizationUser',
    description: 'User model scoped to a specific organization.'
} as const;

export const PolicyAcceptanceSchema = {
    properties: {
        id: {
            type: 'integer',
            title: 'Id',
            description: 'ID of the acceptance record'
        },
        user_id: {
            type: 'string',
            title: 'User Id',
            description: 'ID of the user who accepted'
        },
        policy_type: {
            type: 'string',
            title: 'Policy Type',
            description: 'Type of policy accepted'
        },
        version: {
            type: 'string',
            title: 'Version',
            description: 'Version of the policy accepted'
        },
        accepted_at: {
            type: 'string',
            format: 'date-time',
            title: 'Accepted At',
            description: 'When the policy was accepted'
        },
        user_agent: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Agent',
            description: 'User agent when accepted'
        }
    },
    type: 'object',
    required: [
        'id',
        'user_id',
        'policy_type',
        'version',
        'accepted_at'
    ],
    title: 'PolicyAcceptance',
    description: 'Schema for a policy acceptance record\n\nReturned when retrieving policy acceptance history'
} as const;

export const PolicyAcceptanceRequestSchema = {
    properties: {
        policy_type: {
            type: 'string',
            title: 'Policy Type',
            description: 'Type of policy: \'privacy_policy\' or \'terms_conditions\''
        },
        version: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Version',
            description: 'Policy version (optional, defaults to current version)'
        },
        user_agent: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Agent',
            description: 'User agent string (optional)'
        }
    },
    type: 'object',
    required: [
        'policy_type'
    ],
    title: 'PolicyAcceptanceRequest',
    description: 'Schema for recording user acceptance of a policy (privacy/terms)\n\nUsed when user explicitly accepts a policy with version information'
} as const;

export const PolicyAcceptanceStatusSchema = {
    properties: {
        needs_privacy_policy_acceptance: {
            type: 'boolean',
            title: 'Needs Privacy Policy Acceptance',
            description: 'Needs to accept a (new) privacy policy.'
        },
        privacy_policy_accepted: {
            type: 'boolean',
            title: 'Privacy Policy Accepted',
            description: 'Has accepted current privacy policy'
        },
        privacy_policy_version: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Privacy Policy Version',
            description: 'Version of privacy policy accepted'
        },
        privacy_policy_accepted_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Privacy Policy Accepted At',
            description: 'When privacy policy was accepted'
        },
        needs_terms_conditions_acceptance: {
            type: 'boolean',
            title: 'Needs Terms Conditions Acceptance',
            description: 'Needs to accept a (new) terms of use.'
        },
        terms_conditions_accepted: {
            type: 'boolean',
            title: 'Terms Conditions Accepted',
            description: 'Has accepted current terms of use'
        },
        terms_conditions_version: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Terms Conditions Version',
            description: 'Version of terms of use accepted'
        },
        terms_conditions_accepted_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Terms Conditions Accepted At',
            description: 'When terms of use were accepted'
        }
    },
    type: 'object',
    required: [
        'needs_privacy_policy_acceptance',
        'privacy_policy_accepted',
        'needs_terms_conditions_acceptance',
        'terms_conditions_accepted'
    ],
    title: 'PolicyAcceptanceStatus',
    description: 'Schema for checking if user has accepted current policies.\nUsed to determine if user needs to accept new policy versions.'
} as const;

export const PrepareResponseSchema = {
    properties: {
        auth_url: {
            type: 'string',
            title: 'Auth Url'
        }
    },
    type: 'object',
    required: [
        'auth_url'
    ],
    title: 'PrepareResponse'
} as const;

export const ProcessSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        process_definition: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        }
    },
    type: 'object',
    required: [
        'identity',
        'name'
    ],
    title: 'Process',
    description: 'Request body for Product.'
} as const;

export const ProcessElementSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        is_archived: {
            type: 'boolean',
            title: 'Is Archived',
            default: false
        },
        archived_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        type: {
            $ref: '#/components/schemas/ProcessElementType'
        },
        subtype: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subtype'
        }
    },
    type: 'object',
    required: [
        'identity',
        'bpmn_id',
        'name',
        'type'
    ],
    title: 'ProcessElement',
    description: 'Request body for Task.'
} as const;

export const ProcessElementTypeSchema = {
    type: 'string',
    enum: [
        'task',
        'gateway',
        'event',
        'flow'
    ],
    title: 'ProcessElementType'
} as const;

export const ProcessEventSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        is_archived: {
            type: 'boolean',
            title: 'Is Archived',
            default: false
        },
        archived_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        type: {
            $ref: '#/components/schemas/ProcessElementType',
            default: 'event'
        },
        subtype: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subtype'
        }
    },
    type: 'object',
    required: [
        'identity',
        'bpmn_id',
        'name'
    ],
    title: 'ProcessEvent'
} as const;

export const ProcessFlowSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        is_archived: {
            type: 'boolean',
            title: 'Is Archived',
            default: false
        },
        archived_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        type: {
            $ref: '#/components/schemas/ProcessElementType',
            default: 'flow'
        },
        subtype: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subtype'
        }
    },
    type: 'object',
    required: [
        'identity',
        'bpmn_id',
        'name'
    ],
    title: 'ProcessFlow'
} as const;

export const ProcessGatewaySchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        is_archived: {
            type: 'boolean',
            title: 'Is Archived',
            default: false
        },
        archived_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        type: {
            $ref: '#/components/schemas/ProcessElementType',
            default: 'gateway'
        },
        subtype: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subtype'
        }
    },
    type: 'object',
    required: [
        'identity',
        'bpmn_id',
        'name'
    ],
    title: 'ProcessGateway'
} as const;

export const ProcessInTreeSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        }
    },
    type: 'object',
    required: [
        'identity',
        'name'
    ],
    title: 'ProcessInTree',
    description: 'Process representation inside worktree, does not describe Process.'
} as const;

export const ProcessTaskSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        is_archived: {
            type: 'boolean',
            title: 'Is Archived',
            default: false
        },
        archived_at: {
            anyOf: [
                {
                    type: 'string',
                    format: 'date-time'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Archived At'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        type: {
            $ref: '#/components/schemas/ProcessElementType',
            default: 'task'
        },
        subtype: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Subtype'
        },
        ui_code: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: [
        'identity',
        'bpmn_id',
        'name'
    ],
    title: 'ProcessTask'
} as const;

export const ProductSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: [
        'identity',
        'name'
    ],
    title: 'Product',
    description: 'Request body for Product.'
} as const;

export const ProductInTreeSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        processes: {
            items: {
                $ref: '#/components/schemas/ProcessInTree'
            },
            type: 'array',
            title: 'Processes'
        }
    },
    type: 'object',
    required: [
        'identity',
        'name',
        'processes'
    ],
    title: 'ProductInTree',
    description: 'Product representation inside worktree, does not describe Product.'
} as const;

export const RelationshipDirectionSchema = {
    type: 'string',
    enum: [
        'outgoing',
        'incoming'
    ],
    title: 'RelationshipDirection',
    description: 'Direction of a relationship from the perspective of the current entity.'
} as const;

export const RevocationRequestSchema = {
    properties: {
        token: {
            type: 'string',
            title: 'Token'
        },
        token_type_hint: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Token Type Hint'
        },
        client_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Client Id'
        }
    },
    type: 'object',
    required: [
        'token'
    ],
    title: 'RevocationRequest',
    description: 'Token revocation request.'
} as const;

export const RoleSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        responsibilities: {
            items: {
                $ref: '#/components/schemas/RoleResponsibility'
            },
            type: 'array',
            title: 'Responsibilities',
            default: []
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        },
        description: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        }
    },
    type: 'object',
    required: [
        'identity',
        'name'
    ],
    title: 'Role',
    description: 'Request body for Role.'
} as const;

export const RoleResponsibilitySchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        process_id: {
            type: 'string',
            title: 'Process Id'
        },
        process_name: {
            type: 'string',
            title: 'Process Name'
        },
        bpmn_id: {
            type: 'string',
            title: 'Bpmn Id'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        short_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Short Description'
        }
    },
    type: 'object',
    required: [
        'identity',
        'process_id',
        'process_name',
        'bpmn_id',
        'name'
    ],
    title: 'RoleResponsibility',
    description: 'Process Task is a RoleResponsibility.'
} as const;

export const StekSchema = {
    properties: {
        identity: {
            type: 'string',
            title: 'Identity'
        },
        name: {
            type: 'string',
            title: 'Name'
        },
        fqdn: {
            type: 'string',
            title: 'Fqdn'
        },
        logo: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        description: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        mission: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        vision: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        core_values: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        specializations: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        target_markets: {
            anyOf: [
                {
                    $ref: '#/components/schemas/Artefact'
                },
                {
                    type: 'null'
                }
            ]
        },
        user_artefact_group_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'User Artefact Group Id'
        }
    },
    type: 'object',
    required: [
        'identity',
        'name',
        'fqdn'
    ],
    title: 'Stek',
    description: 'Request body for Stek.'
} as const;

export const StekGeneratedDetailsSchema = {
    properties: {
        description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Description'
        },
        mission: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Mission'
        },
        vision: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Vision'
        },
        core_values: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Core Values'
        },
        specializations: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Specializations'
        },
        target_markets: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Target Markets'
        }
    },
    type: 'object',
    title: 'StekGeneratedDetails',
    description: 'Subsections that define the structure of a stek.'
} as const;

export const SupportedProvidersResponseSchema = {
    properties: {
        task_type: {
            $ref: '#/components/schemas/TaskType',
            description: 'The task type'
        },
        supported_providers: {
            items: {
                $ref: '#/components/schemas/ModelProvider'
            },
            type: 'array',
            title: 'Supported Providers',
            description: 'List of supported providers for this task type'
        }
    },
    type: 'object',
    required: [
        'task_type',
        'supported_providers'
    ],
    title: 'SupportedProvidersResponse',
    description: 'Response containing the supported providers for a task type.'
} as const;

export const TaskEvaluationListResponseSchema = {
    properties: {
        results: {
            items: {
                $ref: '#/components/schemas/TaskEvaluationResult'
            },
            type: 'array',
            title: 'Results',
            description: 'List of task evaluation results'
        }
    },
    type: 'object',
    required: [
        'results'
    ],
    title: 'TaskEvaluationListResponse',
    description: 'Response for listing task evaluations.'
} as const;

export const TaskEvaluationRequestSchema = {
    properties: {
        task_type: {
            $ref: '#/components/schemas/TaskType',
            description: 'Type of task to evaluate'
        },
        task_config: {
            additionalProperties: true,
            type: 'object',
            title: 'Task Config',
            description: 'Configuration parameters for the task'
        },
        agent_config: {
            additionalProperties: true,
            type: 'object',
            title: 'Agent Config',
            description: 'Agent configuration (name, system_message, description)'
        },
        llm_config: {
            $ref: '#/components/schemas/ModelConfig',
            description: 'Model configuration'
        }
    },
    type: 'object',
    required: [
        'task_type',
        'task_config',
        'agent_config',
        'llm_config'
    ],
    title: 'TaskEvaluationRequest',
    description: 'Request for task evaluation.'
} as const;

export const TaskEvaluationResultSchema = {
    properties: {
        task_name: {
            type: 'string',
            title: 'Task Name',
            description: 'Name of the task'
        },
        timestamp: {
            type: 'string',
            title: 'Timestamp',
            description: 'Timestamp of the task execution'
        },
        execution_time_seconds: {
            type: 'number',
            title: 'Execution Time Seconds',
            description: 'Execution time in seconds'
        },
        agent_name: {
            type: 'string',
            title: 'Agent Name',
            description: 'Name of the agent used'
        },
        agent_system_message: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Agent System Message',
            description: 'System message used for instructing the agent'
        },
        agent_description: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Agent Description',
            description: 'Description of the agent'
        },
        prompt: {
            type: 'string',
            title: 'Prompt',
            description: 'Prompt used for the task'
        },
        context_prompt: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Context Prompt',
            description: 'Context prompt used for the task'
        },
        function: {
            type: 'string',
            title: 'Function',
            description: 'Function used to execute the task'
        },
        output: {
            type: 'string',
            title: 'Output',
            description: 'Output of the task'
        },
        llm_config: {
            additionalProperties: true,
            type: 'object',
            title: 'Llm Config',
            description: 'LLM configuration used'
        },
        variation_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Variation Id',
            description: 'Variation identifier if part of a batch run'
        }
    },
    type: 'object',
    required: [
        'task_name',
        'timestamp',
        'execution_time_seconds',
        'agent_name',
        'prompt',
        'function',
        'output',
        'llm_config'
    ],
    title: 'TaskEvaluationResult',
    description: 'Result of a task evaluation.'
} as const;

export const TaskTypeSchema = {
    type: 'string',
    enum: [
        'generate_description',
        'generate_definition_xml',
        'generate_user_interface'
    ],
    title: 'TaskType',
    description: 'Available task types for evaluation.'
} as const;

export const TokenRequestSchema = {
    properties: {
        code: {
            type: 'string',
            title: 'Code'
        },
        state: {
            type: 'string',
            title: 'State'
        },
        redirect_uri: {
            type: 'string',
            title: 'Redirect Uri'
        },
        integration_type: {
            type: 'string',
            title: 'Integration Type'
        }
    },
    type: 'object',
    required: [
        'code',
        'state',
        'redirect_uri',
        'integration_type'
    ],
    title: 'TokenRequest',
    description: 'Request body for token exchange endpoint.'
} as const;

export const UpdateUserSchema = {
    properties: {
        name: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Name'
        },
        profile_picture: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            title: 'Profile Picture'
        }
    },
    type: 'object',
    title: 'UpdateUser',
    description: 'Update a user.'
} as const;

export const ValidationErrorSchema = {
    properties: {
        loc: {
            items: {
                anyOf: [
                    {
                        type: 'string'
                    },
                    {
                        type: 'integer'
                    }
                ]
            },
            type: 'array',
            title: 'Location'
        },
        msg: {
            type: 'string',
            title: 'Message'
        },
        type: {
            type: 'string',
            title: 'Error Type'
        }
    },
    type: 'object',
    required: [
        'loc',
        'msg',
        'type'
    ],
    title: 'ValidationError'
} as const;

export const WidgetSchema = {
    properties: {
        x: {
            type: 'integer',
            title: 'X'
        },
        y: {
            type: 'integer',
            title: 'Y'
        },
        w: {
            type: 'integer',
            title: 'W'
        },
        h: {
            type: 'integer',
            title: 'H'
        },
        content: {
            type: 'string',
            title: 'Content'
        }
    },
    type: 'object',
    required: [
        'x',
        'y',
        'w',
        'h',
        'content'
    ],
    title: 'Widget',
    description: 'Widget within a Dashboard.'
} as const;

export const WorktreeSchema = {
    properties: {
        stek_id: {
            type: 'string',
            title: 'Stek Id'
        },
        domains: {
            items: {
                $ref: '#/components/schemas/DomainInTree'
            },
            type: 'array',
            title: 'Domains'
        }
    },
    type: 'object',
    required: [
        'stek_id',
        'domains'
    ],
    title: 'Worktree',
    description: 'A worktree represents the hierarchy of a system, described in terms of\ndomains, products and processes. It can be used to render a tree view of\nthe system.\n\nNote, the schema does not expose the branch that is used across all\nentities (stek and its domains), unlike the domain entity.'
} as const;

export const UserActivitySchema = {
    description: 'Request body for user activity.',
    properties: {
        session_slug: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            default: null,
            title: 'Session Slug'
        },
        user_name: {
            title: 'User Name',
            type: 'string'
        },
        entity_id: {
            title: 'Entity Id',
            type: 'string'
        },
        photo_url: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            default: null,
            title: 'Photo Url'
        },
        is_editing: {
            title: 'Is Editing',
            type: 'boolean'
        },
        timestamp: {
            title: 'Timestamp',
            type: 'integer'
        }
    },
    required: [
        'user_name',
        'entity_id',
        'is_editing',
        'timestamp'
    ],
    title: 'UserActivity',
    type: 'object',
    example: {
        user_name: 'John Doe',
        entity_id: 'XLx2jeo1lV3qlorN-Pgb8',
        is_editing: true,
        timestamp: 1625097600,
        session_slug: 'browser-1'
    }
} as const;

export const ActivityUpdateSchema = {
    description: 'Request body for activity update.',
    properties: {
        entity_id: {
            anyOf: [
                {
                    type: 'string'
                },
                {
                    type: 'null'
                }
            ],
            default: null,
            title: 'Entity Id'
        },
        is_editing: {
            title: 'Is Editing',
            type: 'boolean'
        }
    },
    required: [
        'is_editing'
    ],
    title: 'ActivityUpdate',
    type: 'object',
    example: {
        entity_id: 'XLx2jeo1lV3qlorN-Pgb8',
        is_editing: false
    }
} as const;
